import { SmoothScroll } from "../lib/lenis";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { Work } from "../components/Work";
import { Process } from "../components/Process";
import { QuoteForm } from "../components/QuoteForm";
import { Contact, Footer } from "../components/Contact";

export default function Landing() {
  return (
    <div className="grain relative min-h-screen bg-[#050706] text-white">
      <SmoothScroll />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Work />
        <Process />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
